import React from 'react';
import Sidebar from '../Sidebar';
import PeoplePosts from '../PeoplePosts';
import FilterSearch from '../filters/FilterSearch';
import FilterButtonGroup from '../filters/FilterButtonGroup';
import useDataContext from '../../context/useDataContext';
import isEmpty from '../../methods/utilities/isEmpty';

function LayoutPeople() {
  return (
    <div className="app-layout blog-a sidebar-top">    
      <PeoplePosts></PeoplePosts>
    </div>
  )
}

export default LayoutPeople;